import React, { useEffect, useState } from "react";
import "../style/login.scss";
import { Icon } from "@iconify/react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";

import { Link, useLocation, useNavigate } from "react-router-dom";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  var authToken = JSON.parse(localStorage.getItem("bearerToken"));

  console.log(location);

  useEffect(() => {
    console.log(authToken);
    if (authToken) {
      navigate("/dashboard");
    }
  }, []);

  const handleLogin = async () => {
    console.log("inside login func");

    // Validation
    if (!validateEmail(email)) {
      setFormErrors({
        ...formErrors,
        email: "Invalid email address",
      });
      return;
    }

    if (password.length < 6) {
      setFormErrors({
        ...formErrors,
        password: "Password must be at least 6 characters long",
      });
      return;
    }

    // Clear previous errors
    setFormErrors({
      username: "",
      email: "",
      phone: "",
      password: "",
      confirmPassword: "",
    });

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/customer/login`, {
        email: email,
        password: password,
      });

      const data = response.data;
      const bearerToken = data.token;

      localStorage.setItem("bearerToken", JSON.stringify(bearerToken));
      localStorage.setItem("email", JSON.stringify(data.email));
      localStorage.setItem("userId", JSON.stringify(data.id));

      console.log("data.email -----------------", data.email);

      if (data.email === "admin@gmail.com") {
        console.log("arvin@grouplandev. here i am authenticated");
        navigate("/dashboard");
      } else {
        navigate("/singleagent");
      }

      toast.success("User Login successfully!");
      console.log("Response from server:", response.data);
    } catch (error) {
      console.log("Error during login:", error?.response?.data);
      toast.error(`Error : ${error?.response?.data}`);
    }
  };
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const handleInputChange = (field, value) => {
    if (field === "phone" && value.length > 12) {
      return;
    }

    setFormData({
      ...formData,
      [field]: value,
    });
    // Clear errors when the user starts typing
    setFormErrors({
      ...formErrors,
      [field]: "",
    });
  };

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });

  const [formErrors, setFormErrors] = useState({
    username: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });

  const togglePasswordVisibility = () => {
    setFormData({
      ...formData,
      passwordVisible: !formData.passwordVisible,
    });
    setPasswordVisible(!passwordVisible);
  };

  return (
    <div className="login-banner">
      <div className="content-left">
        <div className="content-left-mainDiv">
          <p className="content-left-heading">Group LanDev AI</p>
          <span> Going to Help to Plan your Construction</span>
        </div>
      </div>

      <div className="content-right">
        <div className="content-right-container">
          <p>Hello!</p>
          <p className="hello-text">We’re really happy to help you</p>

          <input
            type="email"
            placeholder="Email"
            className="input-fields"
            onChange={(e) => {
              setFormErrors({ ...formErrors, email: "" });
              setEmail(e.target.value);
            }}
          />
          <span style={{ color: "red" }} className="span">
            {formErrors.email}
          </span>

          <div className="pass-wrapper" onChange={(e) => setPassword(e.target.value)}>
            <input
              type={passwordVisible ? "text" : "password"}
              placeholder="Password"
              className="input-fields"
              name="password"
              value={formData.password}
              onChange={(e) => handleInputChange("password", e.target.value)}
              style={{
                border: formErrors.password ? "1px solid red" : "1px solid #ccc",
              }}
            />
            <span style={{ color: "red" }} className="span">
              {formErrors.password}
            </span>

            {passwordVisible ? (
              <Icon icon="el:eye-close" color="#666" width="49" height="30" hFlip={true} className="eye" opacity="1" onClick={togglePasswordVisibility} />
            ) : (
              <Icon icon="bi:eye-fill" color="#666" width="49" height="30" hFlip={true} className="eye" opacity="1" onClick={togglePasswordVisibility} />
            )}
          </div>

          <div className="btnWrapper">
            <Link to="/signup">
              <button type="button" className="signUpBtn">
                Sign up
              </button>
            </Link>

            <button className="gradient-btn-yellow " onClick={() => handleLogin()}>
              Log in
            </button>
          </div>
          <div className="forgetLinkWrapper">
            <a className="forgetLink" href="/forget">
              Forgot Password?
            </a>
          </div>

          <p className="signIn-text">Or sign in with</p>

          <div className="social-media-wrapper">
            <div className="social-icon-box">
              <img src="../../images/home/google.png" alt="" className="google-icon" />
            </div>
            <div className="social-icon-box">
              <img src="../../images/home/facebook.png" alt="" className="google-icon" />
            </div>
            <div className="social-icon-box">
              <img src="../../images/home/twitter.png" alt="" className="google-icon" />
            </div>
          </div>
        </div>
      </div>
      <ToastContainer></ToastContainer>
    </div>
  );
};

export default Login;
